const NOTIFICATION_SOUND_URL = "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/app_store_assets/sounds/chat_new_message.wav";
const CALL_END_SOUND_URL = "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/app_store_assets/sounds/chat-call-end.mp3";
const CALL_RINGING_SOUND_URL = "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/app_store_assets/sounds/chat-calling.mp3";
let audioInstance = null;
let callEndAudio = null;
let callingAudio = null;
let callingTimeout = null;
let incomingRingtoneAudio = null;
let incomingRingtoneTimeout = null;
const CALLING_SOUND_TIMEOUT_MS = 30000;
const INCOMING_RINGTONE_TIMEOUT_MS = 60000;
let lastNotificationTime = 0;
const NOTIFICATION_DEBOUNCE_MS = 500;

export const playMessageNotification = () => {
  try {
    const now = Date.now();
    if (now - lastNotificationTime < NOTIFICATION_DEBOUNCE_MS) {
      return;
    }
    lastNotificationTime = now;

    if (!audioInstance) {
      audioInstance = new Audio(NOTIFICATION_SOUND_URL);
      audioInstance.volume = 0.5;
    }

    audioInstance.currentTime = 0;

    const playPromise = audioInstance.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.log("Message notification sound played");
        })
        .catch((error) => {
          console.warn("Failed to play notification sound:", error);
        });
    }
  } catch (error) {
    console.error("Error playing message notification:", error);
  }
};

export const playCallEndSound = () => {
  try {
    if (!callEndAudio) {
      callEndAudio = new Audio(CALL_END_SOUND_URL);
      callEndAudio.volume = 0.5;
    }
    callEndAudio.currentTime = 0;
    callEndAudio.play().catch((err) => {
      console.warn("Failed to play call end sound:", err);
    });
  } catch (error) {
    console.error("Error playing call end sound:", error);
  }
};

export const playCallingSound = () => {
  try {
    if (callingAudio && !callingAudio.paused) {
      return;
    }
    if (!callingAudio) {
      callingAudio = new Audio(CALL_RINGING_SOUND_URL);
      callingAudio.volume = 0.5;
      callingAudio.loop = true;
    }
    callingAudio.currentTime = 0;
    callingAudio.play().catch((err) => {
      console.warn("Failed to play calling sound:", err);
    });

    if (callingTimeout) {
      clearTimeout(callingTimeout);
    }
    callingTimeout = setTimeout(() => {
      stopCallingSound();
    }, CALLING_SOUND_TIMEOUT_MS);
  } catch (error) {
    console.error("Error playing calling sound:", error);
  }
};

export const stopCallingSound = () => {
  try {
    if (callingTimeout) {
      clearTimeout(callingTimeout);
      callingTimeout = null;
    }
    if (callingAudio) {
      callingAudio.pause();
      callingAudio.currentTime = 0;
    }
  } catch (error) {
    console.error("Error stopping calling sound:", error);
  }
};

export const playIncomingRingtone = (ringtoneUrl) => {
  try {
    stopIncomingRingtone();

    const url = ringtoneUrl || CALL_RINGING_SOUND_URL;
    incomingRingtoneAudio = new Audio(url);
    incomingRingtoneAudio.volume = 0.5;
    incomingRingtoneAudio.loop = true;

    incomingRingtoneAudio.play().catch((err) => {
      console.warn("Failed to play incoming ringtone:", err);
    });

    incomingRingtoneTimeout = setTimeout(() => {
      stopIncomingRingtone();
    }, INCOMING_RINGTONE_TIMEOUT_MS);
  } catch (error) {
    console.error("Error playing incoming ringtone:", error);
  }
};

export const stopIncomingRingtone = () => {
  try {
    if (incomingRingtoneTimeout) {
      clearTimeout(incomingRingtoneTimeout);
      incomingRingtoneTimeout = null;
    }
    if (incomingRingtoneAudio) {
      incomingRingtoneAudio.pause();
      incomingRingtoneAudio.currentTime = 0;
      incomingRingtoneAudio = null;
    }
  } catch (error) {
    console.error("Error stopping incoming ringtone:", error);
  }
};
